export default {
  namespaced: true,
  state: {
    snackbarActive: false,
    content: null,
    buttonUrl: null,
    buttonContent: null,
    timeout: null,
  },
  mutations: {
    OPEN_SNACKBAR(state, data) {
      state.snackbarActive = true;
      state.content = data.content;
      state.buttonContent = data.buttonContent;
      state.buttonUrl = data.buttonUrl;
    },
    CLOSE_SNACKBAR(state) {
      state.snackbarActive = false;
      clearTimeout(state.timeout);
    },
    TIMEOUT_RESET(state, data) {
      clearTimeout(state.timeout);
      state.timeout = setTimeout(() => {
        data.callback();
      }, 2000);
    },
  },
  actions: {
    openSnackbar({ commit }, data) {
      commit('OPEN_SNACKBAR', data);
      commit('TIMEOUT_RESET', {
        callback: () => {
          commit('CLOSE_SNACKBAR');
        },
      });
    },
  },
  closeSnackbar({ commit }) {
    commit('CLOSE_SNACKBAR');
  },
};
